module.exports = __webpack_public_path__ + "img/shuttle_rack.4848959b.jpg";